/* eslint-disable no-restricted-imports */
import { useCallback } from 'react';
import { CpaStatus } from '../../../../data-layer/cpa/types';
import { useDispatch } from '../../../../data-layer/useDispatch';
import { loadUserByIdAsync } from '../../../../data-layer/user/actions';
import { CURRENT_USER_ID } from '../../../../data-layer/user/constants';
import { useCurrentUser } from '../../../../routing/users/useCurrentUser';
import { useExperimentFlag } from '../../../../utils/useExperimentFlag';

export const useCpaTrial = () => {
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    const cpaEnabled = Number(useExperimentFlag('cpa_enabled')) === 1;

    const refreshUserProfile = useCallback(() => {
        dispatch(loadUserByIdAsync(CURRENT_USER_ID));
    }, [dispatch]);

    return {
        isNotRegistered: cpaEnabled && currentUser?.cpaStatus === CpaStatus.NOT_REGISTERED,
        refreshUserProfile,
    };
};
